import { getBridge } from '../store';
import { DB_MANAGER_EXTENSION_ID } from '../dbEngines';

/**
 * Tell the DB Manager guest when the vault's items change (card 6.4 run,
 * 10.10.2026): its sidebar asks for the saved connections once, at
 * activation, and was told again only when the vault unlocked or locked. A
 * connection added in the Vault panel, deleted there, or SYNCED IN from
 * another device stayed invisible until a manual refresh. Rust emits
 * `vault:changed` after every vault mutation (local or pulled); the guest's
 * re-read is idempotent, and a burst (a sync pull) is debounced into one.
 *
 * The Tauri event helper is loaded lazily: the host bridge starts this only
 * inside the app, and its many jest importers never load the event module.
 */
export const RELAY_DEBOUNCE_MS = 300;

export function startDbVaultChangeRelay({
  subscribe,
  push = () => getBridge(DB_MANAGER_EXTENSION_ID)?.postToGuest('__db_connections_changed__', {}),
  delay = RELAY_DEBOUNCE_MS,
} = {}) {
  let timer = null;
  let sub = null;
  let stopped = false;
  const onChange = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      push();
    }, delay);
  };
  const attach = (fn) => {
    if (!stopped) sub = fn('vault:changed', onChange);
  };
  if (subscribe) attach(subscribe);
  else
    import('../../utils/safeTauriEvent')
      .then((m) => attach(m.subscribeTauriEvent))
      .catch(() => {});
  return () => {
    stopped = true;
    clearTimeout(timer);
    sub?.unlisten();
  };
}
